import React, { Component } from "react";
class UnAuthorizedException extends Component {
  state = {};
  render() {
    return <div></div>;
  }
}

export default UnAuthorizedException;
